import { useState, useContext, Fragment } from "react";
import { AuthContext } from "../../Context/AuthContext";
import {  useNavigate } from "react-router-dom";
import useFormStatutorydoc from "../lib/useFormStatutorydoc";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import Spinner from "../../Utils/spinner/loading";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { CiFileOn } from "react-icons/ci";
import { ToastContainer, toast } from "react-toastify";
import "./statutory.css";

const StatutoryDocs = () => {
  const navigate = useNavigate();
  const { handleSubmit, loading, error, success } = useFormStatutorydoc();
  const { token, logout } = useContext(AuthContext); 
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    businessRegistration: null,
    financialStatement: null,
    companyProfile: null,
    itf: null,
    nitf: null,
    // signature: null, // Add signature state
  });
  const [fileDetails, setFileDetails] = useState({
    businessRegistration: null,
    financialStatement: null,
    companyProfile: null,
    itf: null,
    nitf: null,
    // signature: null, // Add signature details
  });

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      [fieldName]: file,
    });

    const fileDetail = {
      name: file.name,
      size: file.size,
    };
    setFileDetails({
      ...fileDetails,
      [fieldName]: fileDetail,
    });
  };

  const handleFileDelete = (fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: null,
    });
    setFileDetails({
      ...fileDetails,
      [fieldName]: null,
    });
  };

  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };


  const handleSaveLogout = async (e) => {
    e.preventDefault();
    setSaving(true);  // Set saving to true when the file upload starts
    const formDataToSend = new FormData();

    formDataToSend.append("businessRegistration", formData.businessRegistration);
    formDataToSend.append("financialStatement", formData.financialStatement);
    formDataToSend.append("companyProfile", formData.companyProfile);
    formDataToSend.append("itf", formData.itf);
    formDataToSend.append("nitf", formData.nitf);
    // formDataToSend.append("signature", formData.signature); 

    try {
      const response = await fetch(
       `${process.env.REACT_APP_SERVER_URL}/charterer/profile/upload/statutoryDocs`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      if (response.ok) {
        // Handle success
        toast.success("Documents uploaded successfully!");
        logout();  // Logout after successful upload
      } else {
        // Handle error
        toast.error("Failed to upload documents!");
      }
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Error uploading documents!");
    } finally {
      setSaving(false);  // Reset saving state
    }
  };

  return (
    <Fragment>
      <ToastContainer/>
    <div className="statutory-container">
      <div className="wrap">
      <div className="header">
        <button onClick={() => navigate("/typeofupdate")}>Back</button>
        <BlackVatugIcon onClick={() => navigate("/")}/> 
        <button className="finished" disabled={saving} onClick={handleSaveLogout}>
          {saving ? "Saving... & Logging out" : "Save & Log out"}
        </button>
      </div>
      <form>
        <h2>Statutory Documents</h2>

        {/* {!fileDetails.signature && (
          <label>
            Signature
            <span>
              <input
                type="file"
                hidden
                accept="image/*" 
                onChange={(e) => handleFileChange(e, "signature")}
              />
              <>
                <UploadIcon />
                <p>
                  Drop image here, <span>or browse</span>
                </p>
                <h5>Supports: JPG, PNG</h5>
              </>
            </span>
          </label>
        )} */}

{/* {fileDetails.signature && (
          <div className="uploaded">
            <div className="wrap">
            <img
              src={URL.createObjectURL(formData.signature)}
              alt="Signature Preview"
              className="file" 
            />
              <div className="in">
                <span>
                  <h3>{fileDetails.signature.name}</h3>
                </span>
                <p>{formatFileSize(fileDetails.signature.size)} - 100% Uploaded</p>
              </div>
            </div>
            <div className="last">
              <IoCheckmarkDoneCircleOutline className="mark" />
              <RiDeleteBin5Line
                onClick={() => handleFileDelete("signature")}
                className="delete"
              />
            </div>
            
           
          </div>
        )} */}

        {!fileDetails.businessRegistration && (
          <label>
            CAC
            <span>
              <input
                type="file"
                hidden
                 accept="application/pdf"
                onChange={(e) => handleFileChange(e, "businessRegistration")}
              />
              <>
                <UploadIcon />
                <p>
                  Drop pdf here, <span>or browse</span>
                </p>
                <h5>Supports: PDF</h5>
              </>
            </span>
          </label>
        )}

        {fileDetails.businessRegistration && (
          <div className="uploaded">
            <div className="wrap">
              <CiFileOn className="file" />
              <div className="in">
                <span>
                  <h3>{fileDetails.businessRegistration.name}</h3>
                </span>
                <p>{formatFileSize(fileDetails.businessRegistration.size)} - 100% Uploaded</p>
              </div>
            </div>
            <div className="last">
              <IoCheckmarkDoneCircleOutline className="mark" />
              <RiDeleteBin5Line
                onClick={() => handleFileDelete("businessRegistration")}
                className="delete"
              />
            </div>
          </div>
        )}

        {!fileDetails.financialStatement && (
          <label>
            Financial Statement
            <span>
              <input
                type="file"
                accept="application/pdf"
                hidden
                onChange={(e) => handleFileChange(e, "financialStatement")}
              />
              <>
                <UploadIcon />
                <p>
                  Drop pdf here, <span>or browse</span>
                </p>
                <h5>Supports: PDF</h5>
              </>
            </span>
          </label>
        )}

        {fileDetails.financialStatement && (
          <div className="uploaded">
            <div className="wrap">
              <CiFileOn className="file" />
              <div className="in">
                <span>
                  <h3>{fileDetails.financialStatement.name}</h3>
                </span>
                <p>{formatFileSize(fileDetails.financialStatement.size)} - 100% Uploaded</p>
              </div>
            </div>
            <div className="last">
              <IoCheckmarkDoneCircleOutline className="mark" />
              <RiDeleteBin5Line
                onClick={() => handleFileDelete("financialStatement")}
                className="delete"
              />
            </div>
          </div>
        )}

        {!fileDetails.companyProfile && (
          <label>
            Company Profile
            <span>
              <input
                type="file"
                hidden
                accept="application/pdf"
                onChange={(e) => handleFileChange(e, "companyProfile")}
              />
              <>
                <UploadIcon />
                <p>
                  Drop pdf here, <span>or browse</span>
                </p>
                <h5>Supports: PDF</h5>
              </>
            </span>
          </label>
        )}

        {fileDetails.companyProfile && (
          <div className="uploaded">
            <div className="wrap">
              <CiFileOn className="file" />
              <div className="in">
                <span>
                  <h3>{fileDetails.companyProfile.name}</h3>
                </span>
                <p>{formatFileSize(fileDetails.companyProfile.size)} - 100% Uploaded</p>
              </div>
            </div>
            <div className="last">
              <IoCheckmarkDoneCircleOutline className="mark" />
              <RiDeleteBin5Line
                onClick={() => handleFileDelete("companyProfile")}
                className="delete"
              />
            </div>
          </div>
        )}

        {!fileDetails.itf && (
          <label>
            ITF
            <span>
              <input
                type="file"
                hidden
                accept="application/pdf"
                onChange={(e) => handleFileChange(e, "itf")}
              />
              <>
                <UploadIcon />
                <p>
                  Drop pdf here, <span>or browse</span>
                </p>
                <h5>Supports: PDF</h5>
              </>
            </span>
          </label>
        )}

        {fileDetails.itf && (
          <div className="uploaded">
            <div className="wrap">
              <CiFileOn className="file" />
              <div className="in">
                <span>
                  <h3>{fileDetails.itf.name}</h3>
                </span>
                <p>{formatFileSize(fileDetails.itf.size)} - 100% Uploaded</p>
              </div>
            </div>
            <div className="last">
              <IoCheckmarkDoneCircleOutline className="mark" />
              <RiDeleteBin5Line
                onClick={() => handleFileDelete("itf")}
                className="delete"
              />
            </div>
          </div>
        )}

        {!fileDetails.nitf && (
          <label>
            NITF
            <span>
              <input
                type="file"
                hidden
                accept="application/pdf"
                onChange={(e) => handleFileChange(e, "nitf")}
              />
              <>
                <UploadIcon />
                <p>
                  Drop pdf here, <span>or browse</span>
                </p>
                <h5>Supports: PDF</h5>
              </>
            </span>
          </label>
        )}

        {fileDetails.nitf && (
          <div className="uploaded">
            <div className="wrap">
              <CiFileOn className="file" />
              <div className="in">
                <span>
                  <h3>{fileDetails.nitf.name}</h3>
                </span>
                <p>{formatFileSize(fileDetails.nitf.size)} - 100% Uploaded</p>
              </div>
            </div>
            <div className="last">
              <IoCheckmarkDoneCircleOutline className="mark" />
              <RiDeleteBin5Line
                onClick={() => handleFileDelete("nitf")}
                className="delete"
              />
            </div>
          </div>
        )}

<button className="finished" onClick={handleFinish} disabled={loading}>
          {loading ? <Spinner /> : "Next"}
        </button>

        {error && <p style={{ margin: "auto", color: "red", fontFamily: "Montserrat" }}>{error}</p>}
        {success && <p style={{ margin: "auto", color: "green", fontFamily: "Montserrat" }}>{success}</p>}
      </form>
      </div>
    </div>
    </Fragment>
  );
};

export default StatutoryDocs;

